import type { Observable as ObservableType } from 'rxjs/Observable';
import fetchText$ from '@atlassian/jira-fetch/src/utils/as-text-stream.tsx';

import { performPutRequest } from '@atlassian/jira-fetch/src/index.tsx';

export type CardsAssignToListRestProps = {
	issueKeys: string[];
	rankBeforeIssueIdOrKey: string | null;
	rankAfterIssueIdOrKey: string | null;
	rankCustomFieldId: number;
	rapidViewId: number;
	target: string;
};
/**
 * Only used to move cards in TMP Kanban backlog
 * same as function below but uses newer fetch request util
 */
export const cardsAssignToListRest = ({
	issueKeys,
	rankBeforeIssueIdOrKey,
	rankAfterIssueIdOrKey,
	rankCustomFieldId,
	rapidViewId,
	target,
}: CardsAssignToListRestProps) =>
	performPutRequest('/rest/greenhopper/1.0/xboard/assignToListAndRank', {
		body: JSON.stringify({
			calculateNewIssuesOrder: false,
			issueKeys,
			rankBeforeIssueIdOrKey,
			rankAfterIssueIdOrKey,
			rankCustomFieldId,
			rapidViewId,
			target,
		}),
	});

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	baseUrl: string,
	rankCustomFieldId: number,
	issueKeys: string[],
	rankBeforeIssueIdOrKey: string | null,
	rankAfterIssueIdOrKey: string | null,
	rapidViewId: number,
	target: string,
): ObservableType<string | null> =>
	fetchText$('/rest/greenhopper/1.0/xboard/assignToListAndRank', {
		method: 'PUT',
		body: JSON.stringify({
			calculateNewIssuesOrder: false,
			issueKeys,
			rankBeforeIssueIdOrKey,
			rankAfterIssueIdOrKey,
			rankCustomFieldId,
			rapidViewId,
			target,
		}),
	});
